import { cn } from '@avanta/shared/utils/cn';

export const fieldIconStyles = cn(
  'size-6 text-(--icon-color)',
  'group-focus-within/input:text-(--icon-color-muted)',
  'group-has-[input:placeholder-shown]/input:text-(--icon-color-muted)',
  'group-has-[input:disabled]/input:text-gray-200',
  'group-data-[has-value=false]/trigger:text-(--icon-color-muted)',
  'group-disabled/trigger:text-gray-200'
);
